import { PLAN_LIMITS, formatNumber } from '@shared/plan-limits';

// Currency configuration - GBP for UK-focused launch
export const CURRENCY = {
  code: 'GBP',
  symbol: '£',
} as const;

// Generate feature strings from shared limits
const starterLimits = PLAN_LIMITS.Starter;
const proLimits = PLAN_LIMITS.Pro;

export const PLANS = {
  starter: {
    name: 'Starter',
    description: 'Perfect for getting started',
    popular: false,
    trialDays: 14,
    pricing: {
      monthly: {
        price: 5900, // in pence (£59)
        interval: 'month' as const,
      },
      annual: {
        price: 58800, // in pence (£588 = £49/mo × 12)
        interval: 'year' as const,
        savings: 12000, // in pence (saves £120/year)
      },
    },
    features: [
      `${formatNumber(starterLimits.enrichmentsPerMonth)} email enrichments/month`,
      `${formatNumber(starterLimits.contactsPerMonth)} uploaded contacts`,
      'Unlimited email accounts',
      'Unlimited email warmup',
      'Email sequences with scheduling',
      'Basic analytics',
      'API access',
      'Email support',
    ],
  },
  pro: {
    name: 'Pro',
    description: 'For growing teams',
    popular: true,
    trialDays: 14,
    pricing: {
      monthly: {
        price: 14900, // in pence (£149)
        interval: 'month' as const,
      },
      annual: {
        price: 142800, // in pence (£1,428 = £119/mo × 12)
        interval: 'year' as const,
        savings: 36000, // in pence (saves £360/year)
      },
    },
    features: [
      'Everything in Starter',
      `${formatNumber(proLimits.enrichmentsPerMonth)} email enrichments/month`,
      `${formatNumber(proLimits.contactsPerMonth)} uploaded contacts`,
      'AI-powered personalization',
      'A/B testing',
      'Advanced analytics & deliverability score',
      'Team workspaces',
      'Priority support',
      'Webhooks & integrations',
    ],
  },
};

export type PlanKey = keyof typeof PLANS;
export type BillingInterval = 'monthly' | 'annual';
export type Plan = typeof PLANS[PlanKey];

